// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"c7c28146","547":"89ae1283"}[chunkId] + ".chunk.js";
};